'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Api = require('../../utils/Api');

var _Api2 = _interopRequireDefault(_Api);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _LinkUser = require('../login/LinkUser');

var _LinkUser2 = _interopRequireDefault(_LinkUser);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = require('react-router-dom');

var _reactIcofont = require('react-icofont');

var _reactIcofont2 = _interopRequireDefault(_reactIcofont);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Heart = function (_React$Component) {
    _inherits(Heart, _React$Component);

    function Heart(props) {
        _classCallCheck(this, Heart);

        var _this = _possibleConstructorReturn(this, (Heart.__proto__ || Object.getPrototypeOf(Heart)).call(this, props));

        _this.onHover = function () {
            _this.favIcon.innerHTML = "favorite";
        };

        _this.onOut = function () {
            _this.favIcon.innerHTML = "favorite_border";
        };

        _this.state = {
            isFavorite: false,
            orderId: ''
        };

        return _this;
    }

    _createClass(Heart, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            this.setState({
                isFavorite: this.props.isFavorite,
                orderId: this.props.orderId
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            if (nextProps) {
                this.setState({
                    isFavorite: nextProps.isFavorite,
                    orderId: nextProps.orderId
                });
            }
        }
    }, {
        key: 'handleHideModal',
        value: function handleHideModal() {
            $('#OrderSuccessModal').modal('hide');
            $('.modal-backdrop').remove();
            $('body').removeClass('modal-open');
            $('body').css('padding-right', '');
        }
    }, {
        key: 'markFavorite',
        value: function markFavorite(e) {
            var _this2 = this;

            e.preventDefault();
            var currentUser = _parse2.default.User.current();
            Utils.showSpinner();

            if (currentUser) {
                var userDetailPtrId = currentUser.id;
                var sessionToken = currentUser.getSessionToken();
                var router = this.props.history;
                var locId = this.props.locId;

                var newFavoriteState = !this.state.isFavorite;
                var orderId = this.state.orderId;

                _Api2.default.markFavOrder(sessionToken, userDetailPtrId, orderId, newFavoriteState).then(function (response) {
                    if (response.data) {
                        var isFavorite = response.data;
                        _this2.setState({
                            isFavorite: newFavoriteState
                        }, function () {
                            Utils.hideSpinner();
                        });
                    }
                }, function (error) {
                    // check the error and alert the invalid session token
                    Utils.hideSpinner();
                    Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var idx = this.props.idx;
            return _react2.default.createElement(
                'a',
                {
                    className: 'btn btn-sm mr-3 cursor-pointer ' + (this.state.isFavorite ? "heart-active" : "heart-box"),
                    href: "#",
                    onClick: function onClick(e) {
                        return _this3.markFavorite(e);
                    },
                    tabIndex: 12 + idx

                },
                _react2.default.createElement('i', { className: 'icofont-heart ' + (this.state.isFavorite ? "icofont-heart-active" : "") })
            );
        }
    }]);

    return Heart;
}(_react2.default.Component);

exports.default = Heart;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Heart.jsx
// module id = 546
// module chunks = 0